"use strict";

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var findIndex_1 = __importDefault(require("lodash/findIndex"));

var isNil_1 = __importDefault(require("lodash/isNil"));

function getTokenIndex(ch, tokens) {
  var result = findIndex_1.default(tokens, function (token) {
    return token.start <= ch && token.end > ch;
  });
  return result >= 0 ? result : null;
}

exports.getTokenIndex = getTokenIndex;

function iterateTokensReverse(editor, position) {
  var lineIndex, line, firstIndex, tokenIndex, token, split, start1, end1, token1, start2, end2, token2, start, end;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        lineIndex = position.line;
        line = editor.getLineTokens(lineIndex);
        firstIndex = getTokenIndex(position.ch, line);
        tokenIndex = isNil_1.default(firstIndex) ? line.length : firstIndex;
        _a.label = 1;

      case 1:
        if (!(lineIndex >= 0)) return [3
        /*break*/
        , 9];
        token = line[tokenIndex];
        split = token && token.start < position.ch && token.end > position.ch;
        if (!(token && split)) return [3
        /*break*/
        , 4];
        start1 = {
          ch: position.ch,
          line: lineIndex
        };
        end1 = {
          ch: token.end,
          line: lineIndex
        };
        token1 = token.string.substring(position.ch - token.start);
        return [4
        /*yield*/
        , {
          start: start1,
          end: end1,
          token: token1,
          type: token.type
        }];

      case 2:
        _a.sent();

        start2 = {
          ch: token.start,
          line: lineIndex
        };
        end2 = {
          ch: position.ch,
          line: lineIndex
        };
        token2 = token.string.substring(0, position.ch - token.start);
        return [4
        /*yield*/
        , {
          start: start2,
          end: end2,
          token: token2,
          type: token.type
        }];

      case 3:
        _a.sent();

        return [3
        /*break*/
        , 8];

      case 4:
        if (!(token && !split)) return [3
        /*break*/
        , 6];
        start = {
          ch: token.start,
          line: lineIndex
        };
        end = {
          ch: token.end,
          line: lineIndex
        };
        return [4
        /*yield*/
        , {
          end: end,
          start: start,
          token: token.string,
          type: token.type
        }];

      case 5:
        _a.sent();

        return [3
        /*break*/
        , 8];

      case 6:
        // Yield null if there's nothing in the array of tokens at this point.
        // This means the iterator is at the end of the first line.
        return [4
        /*yield*/
        , null];

      case 7:
        // Yield null if there's nothing in the array of tokens at this point.
        // This means the iterator is at the end of the first line.
        _a.sent();

        _a.label = 8;

      case 8:
        tokenIndex -= 1;

        if (tokenIndex < 0) {
          return [3
          /*break*/
          , 9];
        }

        return [3
        /*break*/
        , 1];

      case 9:
        return [2
        /*return*/
        ];
    }
  });
}

exports.iterateTokensReverse = iterateTokensReverse;